webpackJsonp([14224551955482],{

/***/ 434:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Notebook","author":"Chris Thierer"}},"markdownRemark":{"id":"/opt/build/repo/src/posts/2018-01-27-hello-world.md absPath of file >>> MarkdownRemark","html":"<p>As is customary, we start off with a friendly “hello, world”!</p>\n<p>I’m planning to use this as a notebook to discuss ideas and projects. I think\nthat fits the definition of a “blog”, but I’d prefer not to use the term\n“blog”, so let’s call this a notebook instead.</p>\n<p>Intended audience: myself. If you want to follow along anyway, enjoy!</p>","frontmatter":{"title":"Hello, world","date":"January 27, 2018"}}},"pathContext":{"id":"/2018-01-27-hello-world/","path":"/2018/01/27/hello-world","slug":"hello-world"}}

/***/ })

});


// WEBPACK FOOTER //
// path---2018-01-27-hello-world-2861a9c47de46298a106.js